import { nextTick } from '@studiometa/js-toolkit/utils';
import {
  Accordion,
  Action,
  DataEffect,
  DataModel,
  Frame,
  FrameForm,
  FrameTarget,
  Panel,
} from '@studiometa/ui';
import PriceRange from '../molecules/PriceRange.js';

/**
 * ProductList component
 */
export default class Facets extends Frame {
  /**
   * ProductList Configuration
   */
  static config = {
    name: 'Facets',
    refs: ['directinput', 'loadmore', 'container', 'counter', 'progress', 'products[]'],
    components: {
      Action,
      FrameForm,
      FrameTarget,
      Panel,
      PanelAccordion: Accordion,
      DataModel,
      DataEffect,
      PriceRange,
    },
    options: {
      productCount: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   * Get total products in listing
   * @returns {void}
   */
  get totalProducts() {
    return this.$refs.products.length;
  }

  /**
   * form
   * @returns {HTMLFormElement}
   */
  get form() {
    return this.$el.querySelector('form');
  }

  /**
   *
   */
  onAfterEnter() {
    document.documentElement.style = '';
  }

  /**
   * Click on loadmore
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onLoadmoreClick({ target }) {
    const url = target.dataset.href;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const results = html.querySelector(`[data-ref="Facets.container"]`);
        console.log('html', html);
        this.hideNewProducts(results);

        nextTick(() => {
          this.$refs.container.innerHTML += results.innerHTML;
        });

        const newLoadmore = html.querySelector(`[data-ref="Facets.loadmore"]`);
        if (newLoadmore) {
          this.$refs.loadmore.dataset.href = newLoadmore.dataset.href;
        } else {
          this.$refs.loadmore.style.display = 'none';
        }

        this.$update();

        nextTick(() => {
          setTimeout(() => {
            this.showNewProducts();
          }, 200);
          this.$refs.progress.style.width = `${(this.totalProducts * 100) / this.$options.productCount}%`;
          this.$refs.counter.innerHTML = this.totalProducts;
        });
      });
  }

  /**
   * Add class to new products to add animation
   * @param  {object} results New container.
   * @returns {void}
   */
  hideNewProducts(results) {
    console.log('results', results);
    results.querySelectorAll('[data-ref="Facets.products[]"]').forEach((element, index) => {
      element.style.transitionDelay = `${index * 50}ms`;
      element.classList.add('opacity-0', 'blur-sm', 'scale-110');
    });
  }

  /**
   * Change class to new products to display them
   * @returns {void}
   */
  showNewProducts() {
    this.$refs.products.forEach((element) => {
      element.classList.remove('opacity-0', 'blur-sm', 'scale-110');
    });
  }
}
